export default "__VITE_ASSET__Dq6HPr6b__"